<template>
    <div
        v-cloak
        class="row"
    >
        <div class="col-xs-12">
            <div class="box box-primary">
                <div class="box-header with-border">
                    <h3 class="box-title">Artisan Commands lists</h3>
                    <div class="box-tools pull-right">
                        <button
                            type="button"
                            class="btn btn-box-tool"
                            data-widget="collapse"
                            data-toggle="tooltip"
                            title="Collapse"
                        >
                            <i class="fa fa-minus"></i>
                        </button>
                    </div>
                </div>
                <!-- /.box-header -->
                <div class="box-body table-responsive no-padding">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Description</th>
                                <th>Arguments</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(command, i) in artisanCommands"
                                :key="i"
                            >
                                <td>{{ command.name }}</td>
                                <td>{{ command.description }}</td>
                                <td>
                                    <div class="input-group input-group-sm">
                                        <input
                                            v-model="command.arguments"
                                            class="form-control"
                                            type="text"
                                        />
                                        <span class="input-group-btn">
                                            <button
                                                type="button"
                                                class="btn btn-success btn-flat"
                                                :disabled="inProcess"
                                                @click="run(command)"
                                            >
                                                Run
                                            </button>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- /.box -->
        </div>
        <main-modal
            v-if="isShowModal"
            :modal="modal"
            @close="isShowModal = false"
        >
        </main-modal>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            artisanCommands: [],
            isShowModal: false,
            modal: {
                class: 'modal-console',
                header: '',
                body: '',
                isBodyHtml: false,
            },
            inProcess: false,
        };
    },
    mounted() {
        let app = this;

        axios
            .get('/dev/artisan-commands/data')
            .then(function (resp) {
                app.artisanCommands = resp.data.commands;
            })
            .catch(function (resp) {
                app.showModal('Error!', resp.data.message || 'Error');
            });
    },
    methods: {
        run(command) {
            if (confirm('Do you really want to run it?')) {
                let app = this;

                app.inProcess = true;

                axios
                    .post('/dev/artisan-commands/run/' + command.name, {
                        arguments: command.arguments,
                    })
                    .then(function (resp) {
                        app.showModal(resp.data.success ? 'Completed!' : 'Error!', '<pre>' + resp.data.output + '</pre>', true);
                    })
                    .catch(function (resp) {
                        app.showModal('Error!', resp.data.message || 'Error');
                    })
                    .finally(function () {
                        app.inProcess = false;
                    });
            }
        },
        showModal(header, body, isBodyHtml = false) {
            this.modal.header = header;
            this.modal.body = body;
            this.modal.isBodyHtml = isBodyHtml;

            this.isShowModal = true;
        },
    },
};
</script>
